import "./RulesView.scss";

import {ContentViewContainer} from "../ContentView";
import {AppContainer} from "../common/AppContainer";
import React, {useEffect} from "react";
import {RulesListView} from "./RulesListView";
import {useAppDispatch, useAppSelector} from "../../hooks/ReduxHooks";
import {RulesService} from "../../services/rules/RulesService";
import {isEmailRuleContent} from "../../domain/ItemContent";
import {getItemContent} from "../../state/ItemState";

export const RulesView = () => {
    const dispatch = useAppDispatch();

    const hasContent = useAppSelector(({itemState}) => isEmailRuleContent(getItemContent(itemState)));

    useEffect(() => {
        RulesService.updateRules(dispatch)
            .catch(console.error);
    });

    return (
        <AppContainer>
            <ContentViewContainer hasContent={hasContent} itemsListElement={<RulesListView/>}/>
        </AppContainer>
    );
}
